import { createContext } from 'react'

const TheContext = createContext(null)

export default TheContext